import type { Dict, SupportedLocale } from '../types'
import { da } from './da'
import { de } from './de'
import { en } from './en'
import { fr } from './fr'
import { nb } from './nb'
import { nl } from './nl'
import { sv } from './sv'

/** All locales bundled with the app. The default/synchronous source for the provider. */
export const bundledDictionaries: Record<SupportedLocale, Dict> = { da, en, de, sv, fr, nl, nb }
